export const EC_VIDEO_CONTENT_TYPE_ID = 3;



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-snippet/ec-video-content-type-id.ts